import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, SITEMAP} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {getSearchBarVariant} from '@helpers';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {HTMLSitemap, InjectSearchOverlay} from '@components';
import {AppState} from '@jobseeker/common-core/types';
import {isCSR} from '@jobseeker/lotus/utils';
import dynamic from 'next/dynamic';
import type {GetServerSidePropsContext} from 'next/types';

type SitemapProps = {
  seoConfig: object;
};

const isAppIimjobs = process.env.APP === 'iimjobs';

const HiristAuthentication = isAppIimjobs
  ? dynamic(
      () =>
        import(
          '@jobseeker/client-harness/components/HiristAuthenticationHarness/AuthForm'
        ),
      {
        ssr: false,
      }
    )
  : null;

const ContactUs = ({seoConfig}: SitemapProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, SITEMAP);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const {
    header: {
      meta: {tabsList},
    },
  } = metaData || {};

  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Sitemap',
      item: '',
    },
  ];

  const {searchOverlay, enableLoginPopup} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isSearchEnabled = useSelector(() => searchOverlay, shallowEqual);

  const onLoginSuccess = () => {
    if (isCSR()) {
      window.location.reload();
    }
  };
  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && HiristAuthentication && (
            <HiristAuthentication
              variant={VersionVariants.VERSION_TWO}
              onSuccess={onLoginSuccess}
              openDialog={enableLoginPopup}
              setOpenDialog={() => {
                dispatch({
                  type: 'AppContext/set_login_popup',
                  payload: false,
                });
              }}
            />
          )}
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
          <HTMLSitemap categories={tabsList} />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const searchBarVariant = await getSearchBarVariant({req: context.req});
    store.dispatch({
      type: 'AppContext/set_ab_variants',
      payload: {searchBar: searchBarVariant},
    });
    const seoConfig = await loadSEO(SITEMAP);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: SITEMAP},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default ContactUs;
